module.exports = __webpack_public_path__ + "img/17.0dfbc70f.png";